import * as types from "./mutations-types";

export default {
    [types.SET_SERVICES_LIST](state, list) {
        state.services_list = list;
    }
};
